import { BookButton as WrappedBookButton } from "PFApp/activities/show/parts/book_button/book_button";

import { useRoleProfileActionButtonsContext } from "../context/role_profile_action_buttons_context";
import css from "./shortlist_buttons.module.scss";

export const BookButton = () => {
  const { role, profile, shortlist, areButtonsDisabled, small } = useRoleProfileActionButtonsContext();

  return (
    <WrappedBookButton
      buttonKind="primary"
      shortlistId={shortlist!.id}
      profileId={profile.id}
      activity={role}
      className={css.shortlistButton}
      disabled={areButtonsDisabled}
      small={small}
    />
  );
};
